<template>
  <div class="content">
    <div class="condition">
      <div class="other_wrap">
        <el-button type="primary" @click="addspeech('add')" size="small">添加话术</el-button>
      </div>
    </div>
    <div class="flexrow_wrap">
      <div class="talk_wrap">
        <div class="talk_title">
          <span>话术分组</span>
          <div class="talk_op">
            <i class="anticon el-icon-plus" @click="addBoxFn=true"></i>
          </div>
        </div>
        <div class="talk_con">
          <div class="talk_item" v-if="addBoxFn">
            <el-input v-model="newCateVal" placeholder="请输入内容"></el-input>
            <div class="add_op">
              <i class="el-icon-check" @click="addNewCateFn"></i>
              <i class="el-icon-close" @click="canleNewCateFn"></i>
            </div>
          </div>
          <div class="talk_item speechItem" :class="cateSonId==item.id?'active':''" v-for="(item,index) in speechList" :key="index">
            <div class="speechItem-left" @click.stop="cateChange(item.id)">
              {{item.name}}
            </div>
            <div class="add_op add-right">
              <i class="el-icon-edit-outline" @click="editCateFn('edit',item)"></i>
              <i class="el-icon-delete" @click="editCateFn('detel',item)"></i>
            </div>
          </div>
          <div class="talk_item noneData" v-if="speechList.length==0">
            暂无数据
          </div>
        </div>
      </div>
      <div class="table_wrap flex_content">
        <el-table :data="cateSonLsit" style="width: 100%">
          <el-table-column prop="content" label="话术内容"></el-table-column>
          <el-table-column prop="keyword" label="关键词" width="250">

          </el-table-column>
          <el-table-column prop="address" label="操作" width="150">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="addspeech('edit', scope.row)">修改</el-button>
              <el-button type="text" size="small" @click="detelLine(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="pag_wrap">
      <el-pagination
              background
              :page-size="page.pagesize"
              :current-page="page.pageindex"
              layout="total, prev, pager, next"
              :total="page.total"
              @current-change="pageIndexChange"></el-pagination>
    </div>    
    <div class="con_split">
      <div class="con_left"></div>
      <div class="con_right"></div>
    </div>
  </div>
</template>
<script>
  import {pagination} from "@/util/util.js";
  export default {
    name: "SettinsSpeech",
    data() {
      return {
        addBoxFn: false,
        speechList: [],
        cateSonLsit: [],
        cateListPage: 0,
        speechListPage: 0,
        newCateVal: '',
        // speechAllPage: 0
        cateSonId: null,
        group_id: "",  // 话术分组id
        page: {
          pageindex: pagination.pageIndex,
          pagesize: pagination.pageSize,
          total: pagination.total
        }
      };
    },
    created() {
      this.InitFn('load')
    },
    methods: {
      InitFn(option) {
        this.axios
            .post('companyadmin/verbal_group/index', {page: this.speechListPage})
            .then(response => {
              if (response.data.code == 0) {
                this.speechList = response.data.list
                if (response.data.list[0].id && option === 'load') {
                  this.cateLsit('')
                }
              } else {
              }
            })
            .catch(response => {
            });
      },
      pageIndexChange(pageindex) {
        this.page.pageindex = pageindex;
        this.cateLsit(this.group_id);
      },
      cateChange(id) {
        this.group_id = id;
        this.cateSonId = id;
        this.page.pageindex = 1;
        this.cateLsit(id);
      },
      cateLsit(id) {
        const loading = this.$loading({
          lock: true,
          text: '设置中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)',
          customClass:'fontColor'
        }); 
        this.axios
            .post('companyadmin/verbal_trick/index', {page: this.page.pageindex, group_id: id})
            .then(response => {
              if (response.data.code == 0) {
                this.cateSonLsit = response.data.list;
                this.page.total = response.data.all_page;
                loading.close();
              } else {
                loading.close();
              }
            })
            .catch(response => {
            });
      },
      addspeech(type, item) {
        if (type === 'add') {
          this.$router.push({name: "speechAdd"});
        } else {
          if(sessionStorage.getItem("menu1")){
             this.$router.push({name: "speechAdd", params: {option: JSON.stringify(item),type:'edit'}});

          }else{
              this.$router.push({path: "speechAdd", query: {option: JSON.stringify(item),type:'edit'}});
          }
         
        }
      },
      addNewCateFn() {
        if (!this.newCateVal) {
          this.$message({
            message: '请填写需要添加的话术分组内容',
            type: 'warning'
          });
          return
        }
        this.axios
            .post('companyadmin/verbal_group/add', {name: this.newCateVal})
            .then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: '添加成功！',
                });
                this.canleNewCateFn()
                this.InitFn('add')
              } else {
              }
            })
            .catch(response => {
            });
      },
      editCateFn(type, item) {
        let self_ = this
        if (type === 'edit') {
          this.$prompt('请输入名称 ', '修改', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /\S/,
            inputErrorMessage: '名称不能为空'
          }).then(({value}) => {
            this.axios
                .post('companyadmin/verbal_group/edit', {group_id: item.id, name: value})
                .then(response => {
                  if (response.data.code == 0) {
                    this.$message({
                      message: '编辑成功!'
                    });
                    self_.InitFn('edit')
                  } else {
                  }
                })
                .catch(response => {
                });
          }).catch(() => {
          });
        } else {
          this.$confirm('确定删除' + item.name + '?', '删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.axios
                .post('companyadmin/verbal_group/delete', {group_id: item.id})
                .then(response => {
                  if (response.data.code == 0) {
                    this.$message({
                      message: '删除成功!'
                    });
                    self_.InitFn('edit')
                  } else {
                  }
                })
                .catch(response => {
                });
          }).catch(() => {
          });
        }
      },
      detelLine(id) {
        let self_ = this
        this.$confirm('确定删除该话术?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.axios
              .post('companyadmin/verbal_trick/delete', {trick_id: id})
              .then(response => {
                if (response.data.code == 0) {
                  this.$message({
                    message: '删除成功!'
                  });
                  self_.cateLsit(this.cateSonId)
                } else {
                }
              })
              .catch(response => {
              });
        }).catch(() => {
        });

      },
      canleNewCateFn() {
        this.addBoxFn = false
        this.newCateVal = ''
      }
    }
  };
</script>
